import { buildEnrichedUser } from 'factories/users';
import {
  getDemoSelectedUser,
  getDemoTeamsForUser,
} from 'redux/modules/users-page/demo/usersPage.demo.selectors';
import { getCurrentlyViewedUserId } from 'redux/selectors/routing';
import { getTeamEntities, getTeamResult } from 'redux/selectors/teams';
import type { IState } from 'redux/state';
import { createSelector } from 'reselect';
import type { User } from 'types/user';
import { getUserRoleById } from './roles';
import { getEnrichedUser } from './user';

export { getCurrentlyViewedUserId };

export const readUsers = (state: IState): Array<User> => state.users.entries;

const getRealSelectedUser = createSelector(
  [getCurrentlyViewedUserId, readUsers, getUserRoleById, getEnrichedUser],
  (userId, users, roleById, currentUser) => {
    const user = users.find(u => u.id === userId);
    return userId === currentUser.id || !user ? currentUser : buildEnrichedUser(user, roleById);
  }
);

export const getSelectedUser = createSelector(
  [getDemoSelectedUser, getRealSelectedUser],
  (demo, real) => demo ?? real
);

const getRealSelectedUserFromUrl = createSelector(
  [getCurrentlyViewedUserId, readUsers, getUserRoleById],
  (userId, users, roleById) => {
    const user = users.find(u => u.id === userId);
    return user ? buildEnrichedUser(user, roleById) : undefined;
  }
);

export const getSelectedUserFromUrl = createSelector(
  [getDemoSelectedUser, getRealSelectedUserFromUrl],
  (demo, real) => demo ?? real
);

const getRealTeamsForUser = createSelector(
  [getCurrentlyViewedUserId, getTeamResult, getTeamEntities],
  (userId, result, entities) => {
    return result
      .filter(team => entities[team].users.map(({ user_id }) => user_id).includes(userId))
      .map(team => entities[team]);
  }
);

export const getTeamsForUser = createSelector(
  [getDemoTeamsForUser, getRealTeamsForUser],
  (demo, real) => demo ?? real
);

export const getHasTeams = createSelector([getTeamsForUser], teams => !!teams.length);
